<template>
  <v-app>
    <div class="top-bar">
      <div class="top-logo">pubby</div>
      <div class="small-nav hidden-md-and-up">
        <div
          class="small-page"
          @click="$router.push('/author')"
          :class="{ 'current-page': this.currentRoute == '/author' }"
        >
          <div class="small-icon">
            <i class="material-icons small-icon-i">free_breakfast</i>
          </div>
          <div class="small-label">Author</div>
        </div>
        <div
          class="small-page"
          @click="$router.push('/reader')"
          :class="{ 'current-page': this.currentRoute == '/reader' }"
        >
          <div class="small-icon">
            <i class="material-icons small-icon-i">book</i>
          </div>
          <div class="small-label">Reader</div>
        </div>
      </div>
      <div class="top-user">
        <user-section></user-section>
      </div>
    </div>
    <div>
      <info-modal
      v-if=suspensionMessage
      title="Your Account Has Been Suspended">
        <v-container>
          <div class="bold">Due to your actions, your account has been suspended for the following reasons:</div>
          <div class="section-container suspension-message">{{suspensionMessage}}</div>
          <div class="bold">You may contact support if you believe this to be an error. 
            </br> Your subscription has been cancelled for you.
          </div>
        </v-container>
      </info-modal>
    </div>
    <div class="app-bar-container hidden-sm-and-down" :class="{'blur-disable': suspensionMessage}">
      <app-bar></app-bar>
    </div>
    <div class="app-page-container" :class="{'blur-disable': suspensionMessage}">
      <AppPage></AppPage>
    </div>
    <find-book v-if="showFindBook"></find-book>
    <refer-program v-if="showReferProgram"></refer-program>
  </v-app>
</template>

<script>
import AppPage from "./components/AppPage";
import AppBar from "./components/AppBar/AppBar";
import UserSection from "./components/AppBar/UserSection";
import FindBook from "@/components/Page/FindBook";
import ReferProgram from "@/components/Page/ReferProgram";

import { mapGetters } from "vuex";
import InfoModal from './components/Form/InfoModal.vue';

export default {
  name: "App",
  components: {
    AppPage,
    AppBar,
    UserSection,
    FindBook,
    ReferProgram,
    InfoModal,
  },
  data() {
    return {
      currentRoute: null,
    };
  },
  computed: {
    ...mapGetters({
      showFindBook: "showFindBook",
      showReferProgram: "showReferProgram",
      suspensionMessage: "suspensionMessage",
    }),
  },
  watch: {
    $route(to, from) {
      this.currentRoute = to.path;
    },
  },
  created() {
    console.log("app created", this.$router.currentRoute.path);
    this.currentRoute = this.$router.currentRoute.path;
  },
};
</script>

<style lang="scss">
.top-logo {
  margin-top: 1px;
  float: left;
}
.top-user {
  float: right;
  width: 296px;
  // background: #fff;
  border-radius: 100px;
  margin-top: 4px;
  margin-right: 0px;
  height: 43px;
}

.app-bar-container {
  position: fixed;
  top: 0px;
  width: $app-bar-width;
  height: 100%;
  background: darken($color-sidebar, 3%);
  border-top: 3px solid darken($color-sidebar, 4%);
  border-right: 0px solid darken(#f9f1ea, 2%);
}

.app-page-container {
  padding-top: $top-bar-height;
  padding-left: $app-bar-width;
}

.blur-disable {
  filter: blur(4px);
  pointer-events: none;
}

.section-container {
  margin: 5px 0px 5px 10px;
  border-bottom: 0px solid #e7e7eb;
  // width: 100%;
}

.suspension-message {
  white-space: pre-line;
}

@media (max-width: 1440px) {
  .content-container {
    padding: 24px 16px 20px 32px !important;
  }
}

@media (max-width: 1024px) {
  .app-page-container {
    padding-top: $top-bar-height;
    padding-left: 0px !important;
  }
  .content-container {
    padding: 20px 16px 20px 16px !important;
  }
  .form-container {
    padding: 20px 16px 20px 16px !important;
  }
  .toolbar-push {
    padding-left: 0 !important;
  }
  .toolbar-title {
    padding-left: 30px !important;
  }
}

.no-hero {
  width: 67%;
  font-family: $font-family;
  font-weight: 500;

  .icon {
    padding: 20px;
    text-align: center;
  }
  .icon-img {
    width: 132px;
  }

  .message {
    color: $color-blue;
    font-size: 17pt;
    font-weight: 700;
    text-align: center;
  }
  .message-small {
    font-size: 16pt !important;
  }
  .sub-message {
    padding-top: 0.3em;
    padding-bottom: 1em;
    max-width: 440px;
    margin: 0 auto;
    color: $color-blue;
    font-size: 13.5pt;
    text-align: center;
  }
}
.bold {
  font-weight: 700;
}

.current-page {
  .small-label {
    color: darken($color-blue, 6%) !important;
  }
}

.is-friend .confirm-read-text {
  display: none !important;
}

@media (max-width: 1024px) {
  .no-hero {
    width: 100%;
  }
}
</style>